/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react'
import Header from './Header';
import SideBar from './SideBar';
import './SelectedApartmentRepairs.scss'
import { useParams, Link } from 'react-router-dom'
import { Row, Col, Card, Table, Modal, Button, Form, FormControl, FormSelect, Spinner } from 'react-bootstrap';
import moment from 'moment';

import { saveAs } from 'file-saver';
import { CSVLink } from 'react-csv';
// import { PDFExport } from '@progress/kendo-react-pdf';

// auth imports
import jwt_decode from "jwt-decode";
import { serverUrl } from "../../serverUrl";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import House5 from '../../assets/img/house5.jpg'
import { BiObjectsHorizontalCenter } from 'react-icons/bi';

const localToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${today.getFullYear()}-${month}-${day}`;
};

const expenseError = (error, fallback) => {
    const data = error?.response?.data ?? error?.data ?? error;
    if (typeof data === 'string') return data;
    if (typeof data?.detail === 'string') return data.detail;
    if (typeof data?.error === 'string') return data.error;

    if (data && typeof data === 'object') {
        const [field, messages] = Object.entries(data)[0] || [];
        const message = Array.isArray(messages) ? messages[0] : messages;
        if (typeof message === 'string') {
            return field && field !== 'non_field_errors' ? `${field}: ${message}` : message;
        }
    }
    return fallback;
};

function SelectedApartmentRepairs() {
    // sidebar and header functions
    const [showSidebar, setShowSidebar] = useState(true);
    function toggleSidebar() {
        setShowSidebar(!showSidebar);
    }
    // getting the id and finding the apparment details
    const { id } = useParams();
    const [apartmentSelected, setApartmentSelected] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [apartmentSelectedRepairs, setApartmentSelectedRepairs] = useState([])
    const [apartmentHouses, setApartmentHouses] = useState([])
    const [landlord, setLandlord] = useState("")

    const accessToken = localStorage.getItem("authTokens");
    let access = "";
    let userId = null;
    try {
        access = JSON.parse(accessToken || "{}").access || "";
        userId = access ? jwt_decode(access).user_id : null;
    } catch (error) {
        // Requests below will show a useful sign-in message instead of crashing
        // the whole expense screen when storage contains a stale token.
    }

    const config = {
        headers: access ? { Authorization: `Bearer ${access}` } : {}
    };

    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const queryParams = Object.fromEntries(searchParams.entries());

    // // from the localstorage get the logged in user
    // useEffect(() => {
    //     setIsLoading(true)
    //     // get the landlord details that are linked to the user
    //     serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config)
    //         .then((res) => {
    //             // get the landlord Id
    //             const landlordIds = res.data.results.map((landlord) => landlord.id);

    //             // Create an array to store all the requests
    //             const requests = landlordIds.map((landlordId) => {
    //                 return serverUrl
    //                     .get(`/landlord/landlord-apartment_name/?landlord_id=${landlordId}`, config)
    //                     .then((res) => {
    //                         return res.data.results;
    //                     })
    //                     .catch((error) => {
    //                         console.log(error);
    //                         return [];
    //                     });
    //             });

    //             // Wait for all requests to complete
    //             Promise.all(requests)
    //                 .then((results) => {
    //                     // Merge the results into a single array
    //                     const mergedResults = [].concat(...results);

    //                     setApartmentSelected(mergedResults.find((apartment) => apartment.id === parseInt(id)));
    //                     setIsLoading(false);
    //                 })
    //                 .catch((error) => {
    //                     console.log(error);
    //                     setIsLoading(false);
    //                 });
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    //     serverUrl.get(`/landlord/react-repair-house-apartment/?apartment_id=${id}`, config)
    //         .then((res) => {
    //             setApartmentSelectedRepairs(res.data.results)
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    //     // get the list of all the houses in the apartment
    //     serverUrl.get(`/landlord/house/?apartment_id=${id}`, config)
    //         .then((res) => {
    //             setApartmentHouses(res.data.results)
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })

    // }, []);




    const fetchLandlordData = useCallback(async () => {
        if (!userId) return;
        try {
            const landlordResponse = await serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config);
            const landlordIds = landlordResponse.data.results.map((landlord) => landlord.id);

            const requests = landlordIds.map((landlordId) =>
                serverUrl
                    .get(`/landlord/landlord-apartment_name/?landlord_id=${landlordId}`, config)
                    .then((res) => res.data.results)
                    .catch(() => [])
            );

            const results = await Promise.allSettled(requests);
            const mergedResults = results
                .filter((result) => result.status === 'fulfilled')
                .flatMap((result) => result.value);

            setApartmentSelected(mergedResults.find((apartment) => apartment.id === parseInt(id)));
        } catch (error) {
            console.error('Error fetching landlord data:', error);
        }
    }, [userId, id, config]);

    const fetchRepairData = useCallback(async () => {
        if (!access) return;
        try {
            const repairResponse = await serverUrl.get(`/landlord/react-repair-house-apartment/?apartment_id=${id}&${searchParams.toString()}`, config);
            setApartmentSelectedRepairs(repairResponse.data.results);
        } catch (error) {
            console.error('Error fetching repair data:', error);
        }
    }, [id, config]);

    const fetchHouseData = useCallback(async () => {
        if (!access) return;
        try {
            const houseResponse = await serverUrl.get(`/landlord/house/?apartment_id=${id}`, config);
            setApartmentHouses(houseResponse.data.results);
        } catch (error) {
            console.error('Error fetching house data:', error);
        }
    }, [id, config]);

    useEffect(() => {
        const fetchData = async () => {
            if (!access || !userId) {
                setIsLoading(false);
                return;
            }
            // setIsLoading(true);
            await fetchLandlordData();
            await fetchRepairData();
            await fetchHouseData();
            setIsLoading(false);
        };

        fetchData();
    }, []);


    // searching function
    const [sortType, setSortType] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);

    const handleSort = (sortField) => {
        setSortType(sortField);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
        // Reset selected row when user starts a new search
        setSelectedRow(null);
    };

    const sortedData = apartmentSelectedRepairs.sort((a, b) => {
        const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
        const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];
        if (sortOrder === "asc") {
            return sortValueA > sortValueB ? 1 : -1;
        } else {
            return sortValueA < sortValueB ? 1 : -1;
        }
    });

    const filteredData = sortedData.filter((item) => {
        const searchableFields = Object.values(item).join(" ").toLowerCase();
        return searchableFields.includes(searchQuery.toLowerCase());
    });



    // design the table to display 10 each per table
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = currentPage === totalPages - 1 ? filteredData.length : startIndex + itemsPerPage;
    const displayedItems = filteredData.slice(startIndex, endIndex);

    const handlePrevPage = () => {
        setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
    };


    // exporting data in excel and in pdf
    const exportCSV = () => {
        const csvData = [
            ['Tenant Name', 'Unit', 'Repair Cost', 'Repair', 'Repair Type'],
            ...apartmentSelectedRepairs.map(item => [item.tenant_name, item.house_name, item.repair_cost, item.repair_name, item.repair_type])
        ];
        const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv;charset=utf-8;' });
        saveAs(csvBlob, 'apartment_repairs.csv');
    };


    // modal for adding new repair case
    const [showModalHouse, setShowModalHouse] = useState(false)

    const handleOpenModalHouse = () => {
        setFormData({
            description: "",
            amount: "",
            house: "",
            posted_date: localToday(),
        });
        setRepairCategory("");
        setRepairType("");
        setShowModalHouse(true);
    };
    const handleCloseModalHouse = () => {
        setShowModalHouse(false);
    };
    const [isSubmittingHouseExpense, setIsSubmittingHouseExpense] = useState(false);
    // form data to be sent to backend on eadding the Repair
    const [formData, setFormData] = useState({
        description: "",
        amount: "",
        house: "",
        posted_date: localToday(),
    });
    // onchange functionality on adding the repair
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }
    const [apartmentRepair, setApartmentRepair] = useState(null)
    const [repairCategory, setRepairCategory] = useState("")
    const [repairType, setRepairType] = useState("")

    // submit of adding a new repair per house
    async function handleSubmitHouse(e) {
        e.preventDefault();

        const amount = Number(formData.amount);
        if (!repairCategory || !repairType) {
            toast.error("Select both an expense category and expense type.");
            return;
        }
        if (repairCategory === "unit" && !formData.house) {
            toast.error("Select the unit for this expense.");
            return;
        }
        if (!formData.description.trim()) {
            toast.error("Enter an expense description.");
            return;
        }
        if (!Number.isInteger(amount) || amount < 0) {
            toast.error("Enter a non-negative whole expense amount.");
            return;
        }
        if (!formData.posted_date) {
            toast.error("Select the expense date.");
            return;
        }
        if (!access || !userId) {
            toast.error("Your session has expired. Please sign in again.");
            return;
        }

        setIsSubmittingHouseExpense(true);

        try {
            const data = {
                description: formData.description.trim(),
                amount,
                apartment: Number(id),
                house: repairCategory === "unit" ? Number(formData.house) : null,
                posted_date: formData.posted_date,
                repair_category: repairCategory,
                expense_category: repairType
            };

            await serverUrl.post(`/landlord/repairs-expense/`, data, config);

            setFormData({
                description: "",
                amount: "",
                house: "",
                posted_date: localToday(),
            });
            setRepairCategory("");
            setRepairType("");
            setShowModalHouse(false);
            setCurrentPage(0);
            await fetchRepairData();
            toast.success('Successfully added an expense.');
        } catch (error) {
            toast.error(expenseError(error, 'Unable to add expense.'));
        } finally {
            setIsSubmittingHouseExpense(false);
        }
    }
    const [backgroundImage, setBackgroundImage] = useState('');
    useEffect(() => {
        const getRandomImage = () => {
            let storedImage = localStorage.getItem('backgroundImage');
            if (!storedImage) {
                storedImage = '';
            }

            let randomNumber = Math.floor(Math.random() * 11) + 1;
            const invalidNumbers = [0, -1];
            while (invalidNumbers.includes(randomNumber) || storedImage.endsWith(`${randomNumber}.jpg`)) {
                randomNumber = Math.floor(Math.random() * 11) + 1;
            }

            const imageUrl = `https://kodinyumba.app/media/repairs/repairs${randomNumber}.jpg`;
            setBackgroundImage(imageUrl);
            localStorage.setItem('backgroundImage', imageUrl);
            setIsLoading(false);
        };

        getRandomImage();
    }, []);

    // set is active to false when clicked
    const [showModal, setShowModal] = useState(false);
    const [deleteFormData, setDeleteFormData] = useState({});

    const handleModalOpen = (repair) => {
        setShowModal(true);
        setDeleteFormData(repair)
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    function handleDelete() {
        // update the status of the issue to false
        const data = {
            "is_active": false

        }
        serverUrl.delete(`/landlord/repairs-expense/${deleteFormData.id}/`, config)
            .then((res) => {
                console.log(res)
                const updatedActiveIssues = apartmentSelectedRepairs.filter(repair => repair.id !== deleteFormData.id);
                setApartmentSelectedRepairs(updatedActiveIssues);
                toast.success('Successfully Deleted the Repair');
                handleModalClose();
            })
            .catch((error) => {
                console.log(error)
            })
    }
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [editFormData, setEditFormData] = useState({});
    const handleEdit = (repair) => {
        console.log('repair data', repair)
        setEditFormData(repair);
        setShowModalEdit(true);
    };

    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const dataSent = {
            description: editFormData.repair_name,
            repair_category: editFormData.repair_type,
            posted_date: editFormData.repair_date,
            house: editFormData.house,
            amount: editFormData.repair_cost,
            apartment: id,

        }
        try {
            await serverUrl.put(`/landlord/repairs-expense/${editFormData.id}/`, dataSent, config);
            window.location.reload()
            setApartmentSelectedRepairs((prev) =>
                prev.map((repair) => (repair.id === editFormData.id ? editFormData : repair))
            );
            toast.success('Repair updated successfully!');
            setShowModalEdit(false);
        } catch (error) {
            toast.error('Error updating repair.');
            console.error(error);
        }
    };

    return (
        <>
          

            <div className='repair_apartment'>
                {/* top display of the report */}
                <div className='image_Apartment_report'>
                    {/* <img src={apartmentSelected.image} alt={apartmentSelected.name} /> */}
                    <img src={backgroundImage} alt={apartmentSelected.name} />
                    <p>{apartmentSelected.name} Expenses</p>
                    <span>{apartmentSelected.location}</span>
                </div>
                <Card className='cardProperty d-none'>

                    <Form.Select size='sm' className='formProperty'>
                        <option>By Date</option>
                        <option>This Week</option>
                        <option>This Month</option>
                        <option>This Year</option>
                    </Form.Select>

                    <Form.Select size='sm' className='formProperty'>
                        <option>Type</option>
                        <option>Property</option>
                        <option>Unit</option>

                    </Form.Select>

                    <Form.Select size='sm' className='formProperty'>
                        <option>Unit</option>
                        {apartmentSelectedRepairs.map((defaulter, index) =>
                            <option>{defaulter.house_name}</option>
                        )}
                    </Form.Select>

                    <Form.Select size='sm' className='formProperty'>
                        <option>Tenant Name</option>
                        {apartmentSelectedRepairs.map((defaulter, index) =>
                            <option>{defaulter.tenant_name}</option>
                        )}
                    </Form.Select>



                </Card>


                {/* display the houses that had defaulters */}

                <div className='tasks mt-4' >
                    <Button className='add_repair' onClick={handleOpenModalHouse}>Add Expense</Button>
                    {/* modal used in adding the Expenses of the selected house */}
                    <Modal show={showModalHouse} onHide={handleCloseModalHouse}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add A New Expense</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleSubmitHouse}>
                                {/* category of the repair */}
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <FormSelect
                                        className='input-field'
                                        name="repair_category"
                                        onChange={(e) => {
                                            setRepairCategory(e.target.value);
                                            setFormData((current) => ({ ...current, house: "" }));
                                        }}
                                        value={repairCategory}
                                        required
                                    >
                                        <option disabled value="">Select Expense Category</option>
                                        <option value='apartment'> Apartment Expense</option>
                                        <option value='unit'>Unit Expense</option>
                                    </FormSelect>

                                </div>

                                {/* display the units or apartment */}
                                {repairCategory === 'unit' && (
                                    <div className="input-icons">
                                        <i className="fa fa-hashtag icon"></i>
                                        <FormSelect className='input-field' name="house" onChange={handleChange} value={formData.house} required>
                                            <option disabled value="">Select Unit</option>

                                            {apartmentHouses.map((house) => (
                                                <option key={house.id} value={house.id}>{house.house_number}</option>
                                            ))}
                                        </FormSelect>

                                    </div>
                                )}
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <FormSelect className='input-field' name="expense_category" onChange={(e) => setRepairType(e.target.value)} value={repairType} required>
                                        <option disabled value="">Select Expense Type</option>
                                        <option value='wifi'> WiFi</option>
                                        <option value='repair'>Repair</option>
                                        <option value='water'>Water</option>
                                        <option value='salary'>Salary</option>
                                        <option value='security'>Security</option>
                                        <option value='other'>Other</option>
                                    </FormSelect>

                                </div>



                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="text"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder={"Expense Description"}
                                        required
                                    />
                                </div>

                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="date"
                                        name="posted_date"
                                        value={formData.posted_date}
                                        onChange={handleChange}
                                        placeholder={"Expense Date"}
                                        required
                                    />
                                </div>
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="number"
                                        name="amount"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        placeholder={"Expense Amount"}
                                        min="0"
                                        step="1"
                                        required
                                    />
                                </div>



                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="nextBtn mt-3"
                                    disabled={isSubmittingHouseExpense}
                                >
                                    {isSubmittingHouseExpense ? <Spinner size="sm" /> : <>Save</>}
                                </Button>

                            </Form>
                        </Modal.Body>
                        <Modal.Footer>

                            <Button variant="success" onClick={handleCloseModalHouse} >
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <h5 className='text-center fs-3'>Expenses for {apartmentSelected.name}</h5>
                    <div className='d-flex justify-content-between'>
                        <Form className="searchBar bg-white">
                            <FormControl type="text" placeholder="Search" onChange={handleSearch} />
                        </Form>

                        <div>
                            <Button className='btn btn-sm btn-success text-white me-3' onClick={exportCSV}> EXCEL <i className='bi bi-file-earmark-excel '></i></Button>
                        </div>

                    </div>

                    <Table className='table mt-3'>
                        <thead className="">
                            <th>House Name</th>
                            <th>Expense</th>
                            <th>Expense Cost</th>
                            <th>Tenant Name</th>
                            <th>Tenant Number</th>
                            <th>Expense Type</th>
                            <th>Expense Category</th>
                            <th>Expense Date</th>
                            <th>Edit Expense</th>
                            <th>Delete Expense</th>


                        </thead>
                        <tbody>
                            {displayedItems.map((Defaulter) =>
                                <tr key={Defaulter.id}>
                                    <td>{Defaulter.house_name}</td>
                                    <td>{Defaulter.repair_name}</td>
                                    <td>Ksh. {Defaulter.repair_cost?.toLocaleString()}</td>
                                    <td>{Defaulter.tenant_name}</td>
                                    <td>{Defaulter.tenant_phone}</td>
                                    <td className='text-capitalize'>{Defaulter.repair_type ? Defaulter.repair_type : 'Unit'}</td>
                                    <td className='text-capitalize'>{Defaulter.repair_category}</td>
                                    <td className='text-capitalize'>  {moment(Defaulter.repair_date).format('DD-MM-YYYY')}                                    </td>


                                    <td><i className='bi bi-pen-fill text-primary ' onClick={() => handleEdit(Defaulter)}></i></td>

                                    <td><i className='bi bi-trash-fill text-danger ' onClick={() => handleModalOpen(Defaulter)}></i></td>

                                    <Modal show={showModal} onHide={handleModalClose}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Repair for House {deleteFormData.house_name}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            Are you sure you want to delete this Repair?
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleDelete} >
                                                Yes
                                            </Button>
                                            <Button variant="success" onClick={handleModalClose} >
                                                No
                                            </Button>
                                        </Modal.Footer>

                                    </Modal>
                                </tr>

                            )}

                        </tbody>
                    </Table>
                    {/* get the display of the items 5 per page */}
                    <div className="pagination">
                        <button onClick={handlePrevPage} disabled={currentPage === 0}>
                            &lt;
                        </button>
                        <span>{`${startIndex + 1}-${endIndex} of ${apartmentSelectedRepairs.length}`}</span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages - 1}>
                            &gt;
                        </button>
                    </div>

                    <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Expense</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleEditSubmit}>
                                {/* field to be added : house name, expense decsription, repair type, */}
                                {/* category of the repair */}
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <FormSelect className='input-field' name="repair_type" onChange={handleEditChange}
                                        value={editFormData.repair_type || ''}>
                                        <option disabled selected value="">Select Expense Category</option>
                                        <option value='apartment'> Apartment Expense</option>
                                        <option value='unit'>Unit Expense</option>
                                    </FormSelect>

                                </div>

                                {/* display the units or apartment */}
                                {editFormData.repair_type === 'unit' && (
                                    <div className="input-icons">
                                        <i className="fa fa-hashtag icon"></i>
                                        <FormSelect className='input-field' name="house" onChange={handleEditChange} value={editFormData.house}>
                                            <option disabled value="">Select Unit</option>

                                            {apartmentHouses.map((house) => (
                                                <option key={house.id} value={house.id}>{house.house_number}</option>
                                            ))}
                                        </FormSelect>

                                    </div>
                                )}
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <FormSelect className='input-field' name="repair_category" onChange={handleEditChange} value={editFormData.repair_category || ''}
                                    >
                                        <option disabled selected value="">Select Expense Type</option>
                                        <option value='wifi'> WiFi</option>
                                        <option value='repair'>Repair</option>
                                        <option value='water'>Water</option>
                                        <option value='salary'>Salary</option>
                                        <option value='security'>Security</option>
                                        <option value='other'>Other</option>
                                    </FormSelect>

                                </div>

                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="text"
                                        name="repair_name"
                                        value={editFormData.repair_name || ''}
                                        onChange={handleEditChange}
                                        placeholder={"Expense Name"}
                                        required
                                    />
                                </div>

                                {/* <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="text"
                                        name="repair_name"
                                        value={editFormData.repair_name || ''}
                                        onChange={handleEditChange}
                                        placeholder={"Expense Category"}
                                        required
                                    />
                                </div> */}

                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="date"
                                        name="repair_date"
                                        value={editFormData.repair_date || ''}
                                        onChange={handleEditChange}
                                        placeholder={"Expense Date"}
                                        required
                                    />
                                </div>
                                <div className="input-icons">
                                    <i className="fa fa-hashtag icon"></i>
                                    <input
                                        className="input-field"
                                        type="number"
                                        name="repair_cost"
                                        value={editFormData.repair_cost || ''}
                                        onChange={handleEditChange}
                                        placeholder={"Expense Cost"}
                                        required
                                    />
                                </div>

                                <Button type="submit" className="mt-3">
                                    Save Changes
                                </Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </div>
            </div >
        </>
    )
}

export default SelectedApartmentRepairs
